// extracted by mini-css-extract-plugin
export default {"HelloHi":"Hello_HelloHi__Opy9K","HelloName":"Hello_HelloName__ZPrp6","HelloSenior":"Hello_HelloSenior__ymbxi","HelloXp":"Hello_HelloXp__nTsI5"};